import Path from "../../services/paths";
import ConsumerPromotionActions from "../actions/consumerPromotionActions";
import utils from "../common/utils";
import axios from "axios";
import { getCookie } from '../../util-functions/util-funtions';
import CustomToast from "../../util-functions/customToast";

class ConsumerPromotionMiddleware {
  static createConsumerPromotion(
    consumerPromotionObj
  ) {
    const csrftoken = getCookie('csrftoken');
    let url = `${Path.CREATE_CONSUMER_PROMOTION}`;
    return dispatch => {
      dispatch(ConsumerPromotionActions.consumerPromotionRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "POST",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              'X-CSRFToken': csrftoken
            },
            data: JSON.stringify(consumerPromotionObj)
          })
            .then(res => {
              console.log(res)
              if (res.status === 200) {
                dispatch(ConsumerPromotionActions.consumerPromotionSuccessul(res.data));
              }
              else {
                dispatch(ConsumerPromotionActions.consumerPromotionFailed('error'));
              }
            })
            .catch(error => {
              dispatch(ConsumerPromotionActions.consumerPromotionFailed(error));
            });
        })
        .catch(error => {
          dispatch(ConsumerPromotionActions.consumerPromotionFailed(error));
        });
    };
  }

  static getConsumerPromotionById(
    id
  ) {
    let url = `${Path.BASE_URL}/activity/${id}/get_cp_promotion/`;

    return dispatch => {
      dispatch(ConsumerPromotionActions.getConsumerPromotionByIdRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 200) {
                dispatch(ConsumerPromotionActions.getConsumerPromotionByIdSuccessul(res.data));
              }
              else {
                dispatch(ConsumerPromotionActions.getConsumerPromotionByIdFailed('error'));
              }
            })
            .catch(error => {
              dispatch(ConsumerPromotionActions.getConsumerPromotionByIdFailed(error));
            });
        })
        .catch(error => {
          dispatch(ConsumerPromotionActions.getConsumerPromotionByIdFailed(error));
        });
    };
  }

  static consumerPromotionTypes() {
    let url = `${Path.CONSUMER_PROMOTION_TYPES}`;

    return dispatch => {
      dispatch(ConsumerPromotionActions.consumerPromotionTypesRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 200) {
                dispatch(ConsumerPromotionActions.consumerPromotionTypesSuccessul(res.data));
              }
              else {
                dispatch(ConsumerPromotionActions.consumerPromotionTypesFailed('error'));
              }
            })
            .catch(error => {
              dispatch(ConsumerPromotionActions.consumerPromotionTypesFailed(error));
            });
        })
        .catch(error => {
          dispatch(ConsumerPromotionActions.consumerPromotionTypesFailed(error));
        });
    };
  }

  static updateConsumerPromotion(
    id,
    data
  ) {
    const csrftoken = getCookie('csrftoken');
    let url = `${Path.BASE_URL}/activity/${id}/update_cp_promotion/`;

    return dispatch => {
      dispatch(ConsumerPromotionActions.updateConsumerPromotionRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "POST",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              'X-CSRFToken': csrftoken
            },
            data: JSON.stringify(data)
          })
            .then(res => {
              console.log(res)
              if (res.status === 200) {
                dispatch(ConsumerPromotionActions.updateConsumerPromotionSuccessul(res.data));
              }
              else {
                dispatch(ConsumerPromotionActions.updateConsumerPromotionFailed('error'));
              }
            })
            .catch(error => {
              dispatch(ConsumerPromotionActions.updateConsumerPromotionFailed(error));
            });
        })
        .catch(error => {
          dispatch(ConsumerPromotionActions.updateConsumerPromotionFailed(error));
        });
    };
  }

  static consumerPromotionList(
    pageNo,
    selectedYear,
    selectedWeekFrom,
    selectedWeekTo,
    selectedCategory,
    selectedBrand,
    selectedMasterSku,
    selectedCPStatus,
    selectedCPType,
    selectedCodes
  ) {
    let url = `${Path.CONSUMER_PROMOTION_LIST}?`;

    if (pageNo) {
      url += `page=${pageNo}&`;
    }
    if (selectedYear) {
      url += `year=${selectedYear}&`;
    }
    if (selectedWeekFrom) {
      url += `week_from=${selectedWeekFrom}&`;
    }
    if (selectedWeekTo) {
      url += `week_to=${selectedWeekTo}&`;
    }
    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `category=${element}&`;
      });
    }
    if (Array.isArray(selectedBrand)) {
      selectedBrand.forEach(element => {
        url += `brand=${element}&`;
      });
    }
    if (Array.isArray(selectedMasterSku)) {
      selectedMasterSku.forEach(element => {
        url += `master_sku=${element}&`;
      });
    }
    if (Array.isArray(selectedCPStatus)) {
      selectedCPStatus.forEach(element => {
        url += `cp_status=${element}&`;
      });
    }
    if (selectedCPType) {
      url += `cp_type=${selectedCPType}&`;
    }
    if (Array.isArray(selectedCodes)) {
      selectedCodes.forEach(element => {
        url += `code=${element}&`;
      });
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(ConsumerPromotionActions.getConsumerPromotionListRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 200) {
                dispatch(ConsumerPromotionActions.getConsumerPromotionListSuccessul(res.data));
              }
              else {
                dispatch(ConsumerPromotionActions.getConsumerPromotionListFailed('error'));
              }
            })
            .catch(error => {
              dispatch(ConsumerPromotionActions.getConsumerPromotionListFailed(error));
            });
        })
        .catch(error => {
          dispatch(ConsumerPromotionActions.getConsumerPromotionListFailed(error));
        });
    };
  }

  static submitConsumerPromotion(
    id,
    data
  ) {
    const csrftoken = getCookie('csrftoken');
    let url = `${Path.BASE_URL}/activity/${id}/submit_cp_promotion/`;

    return dispatch => {
      dispatch(ConsumerPromotionActions.submitConsumerPromotionRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "POST",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              'X-CSRFToken': csrftoken
            },
            data: JSON.stringify(data)
          })
            .then(res => {
              console.log(res)
              if (res.status === 200) {
                dispatch(ConsumerPromotionActions.submitConsumerPromotionSuccessul(res.data));
              }
              else {
                dispatch(ConsumerPromotionActions.submitConsumerPromotionFailed('error'));
              }
            })
            .catch(error => {
              dispatch(ConsumerPromotionActions.submitConsumerPromotionFailed(error));
            });
        })
        .catch(error => {
          dispatch(ConsumerPromotionActions.submitConsumerPromotionFailed(error));
        });
    };
  }

  static getConsumerPromotionHistory(
    selectedCategory,
    selectedBrand,
    selectedMasterSku
  ) {
    let url = `${Path.CONSUMER_PROMOTION_HISTORY}?`;

    if (selectedCategory && !Array.isArray(selectedCategory)) {
      url += `category=${selectedCategory}&`;
    }

    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `category=${element}&`;
      });
    }

    if (selectedBrand && !Array.isArray(selectedBrand)) {
      url += `brand=${selectedBrand}&`;
    }

    if (Array.isArray(selectedBrand)) {
      selectedBrand.forEach(element => {
        url += `brand=${element}&`;
      });
    }

    if (selectedMasterSku && !Array.isArray(selectedMasterSku)) {
      url += `master_sku=${selectedMasterSku}&`;
    }

    if (Array.isArray(selectedMasterSku)) {
      selectedMasterSku.forEach(element => {
        url += `master_sku=${element}&`;
      });
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(ConsumerPromotionActions.consumerPromotionHistoryRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 200) {
                dispatch(ConsumerPromotionActions.consumerPromotionHistorySuccessul(res.data));
              }
              else {
                dispatch(ConsumerPromotionActions.consumerPromotionHistoryFailed('error'));
              }
            })
            .catch(error => {
              dispatch(ConsumerPromotionActions.consumerPromotionHistoryFailed(error));
            });
        })
        .catch(error => {
          dispatch(ConsumerPromotionActions.consumerPromotionHistoryFailed(error));
        });
    };
  }

  static deactivateConsumerPromotion(
    id
  ) {
    const csrftoken = getCookie('csrftoken');
    let url = `${Path.BASE_URL}/activity/${id}/deactive_cp_promotion/`;

    return dispatch => {
      dispatch(ConsumerPromotionActions.deactivateConsumerPromotionRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "POST",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              'X-CSRFToken': csrftoken
            }
          })
            .then(res => {
              if (res.status === 200) {
                dispatch(ConsumerPromotionActions.deactivateConsumerPromotionSuccessul(res.data));
              }
              else {
                dispatch(ConsumerPromotionActions.deactivateConsumerPromotionFailed('error'));
              }
            })
            .catch(error => {
              dispatch(ConsumerPromotionActions.deactivateConsumerPromotionFailed(error));
            });
        })
        .catch(error => {
          dispatch(ConsumerPromotionActions.deactivateConsumerPromotionFailed(error));
        });
    };
  }

  static deleteConsumerPromotion(
    id
  ) {
    const csrftoken = getCookie('csrftoken');
    let url = `${Path.DELETE_CONSUMER_PROMOTION}`;
    return dispatch => {
      dispatch(ConsumerPromotionActions.deleteConsumerPromotionRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "DELETE",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              'X-CSRFToken': csrftoken
            },
            data: JSON.stringify({ "guids": [id] })
          })
            .then(res => {
              if (res.status === 200) {
                dispatch(ConsumerPromotionActions.deleteConsumerPromotionSuccess(res.data));
              }
              else {
                dispatch(ConsumerPromotionActions.deleteConsumerPromotionFailed('error'));
              }
            })
            .catch(error => {
              CustomToast('error', 'Activity deletion failed!');
              dispatch(ConsumerPromotionActions.deleteConsumerPromotionFailed(error));
            });
        })
        .catch(error => {
          dispatch(ConsumerPromotionActions.deleteConsumerPromotionFailed(error));
        });
    };
  }

  static getConsumerPromotionListCount(
    pageNo,
    selectedYear,
    selectedWeekFrom,
    selectedWeekTo,
    selectedCategory,
    selectedBrand,
    selectedMasterSku,
    selectedCPType,
    selectedCodes
  ) {
    let url = `${Path.CONSUMER_PROMOTION_LIST_COUNT}?`;

    if (pageNo) {
      url += `page=${pageNo}&`;
    }
    if (selectedYear) {
      url += `year=${selectedYear}&`;
    }
    if (selectedWeekFrom) {
      url += `week_from=${selectedWeekFrom}&`;
    }
    if (selectedWeekTo) {
      url += `week_to=${selectedWeekTo}&`;
    }
    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `category=${element}&`;
      });
    }
    if (Array.isArray(selectedBrand)) {
      selectedBrand.forEach(element => {
        url += `brand=${element}&`;
      });
    }
    if (Array.isArray(selectedMasterSku)) {
      selectedMasterSku.forEach(element => {
        url += `master_sku=${element}&`;
      });
    }
    if (selectedCPType) {
      url += `cp_type=${selectedCPType}&`;
    }
    if (Array.isArray(selectedCodes)) {
      selectedCodes.forEach(element => {
        url += `code=${element}&`;
      });
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(ConsumerPromotionActions.getConsumerPromotionListCountRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 200) {
                dispatch(ConsumerPromotionActions.getConsumerPromotionListCountSuccessul(res.data));
              }
              else {
                dispatch(ConsumerPromotionActions.getConsumerPromotionListCountFailed('error'));
              }
            })
            .catch(error => {
              dispatch(ConsumerPromotionActions.getConsumerPromotionListCountFailed(error));
            });
        })
        .catch(error => {
          dispatch(ConsumerPromotionActions.getConsumerPromotionListCountFailed(error));
        });
    };
  }
}

export default ConsumerPromotionMiddleware;